import type { ComponentType } from 'react';
import type { NavigateFunction } from 'react-router-dom';
import { Compass, Upload, ClipboardList, FileText, HelpCircle, LifeBuoy } from 'lucide-react';
import type { messages as MSG } from '@/lib/i18n.messages';
import type { NeuNeuActionId } from './types';
import { startNeuNeuTour } from './neuNeuTour';

type TKey = keyof typeof MSG;

export interface NeuNeuAction {
  id: NeuNeuActionId;
  labelKey: TKey;
  icon: ComponentType<{ className?: string }>;
  run: (ctx: { navigate: NavigateFunction; t: (key: TKey) => string; closePanel: () => void }) => void;
}

export const NEUNEU_ACTIONS: NeuNeuAction[] = [
  {
    id: 'tour',
    labelKey: 'neuneu.action.tour',
    icon: Compass,
    run: ({ t, closePanel }) => {
      closePanel();
      startNeuNeuTour(t);
    },
  },
  {
    id: 'questionnaire',
    labelKey: 'neuneu.action.questionnaire',
    icon: ClipboardList,
    run: ({ navigate, closePanel }) => {
      closePanel();
      navigate('/toolkits/audit?tab=questionnaire');
    },
  },
  {
    id: 'upload',
    labelKey: 'neuneu.action.upload',
    icon: Upload,
    run: ({ navigate, closePanel }) => {
      closePanel();
      navigate('/toolkits/audit?tab=upload');
    },
  },
  {
    id: 'reports',
    labelKey: 'neuneu.action.reports',
    icon: FileText,
    run: ({ navigate, closePanel }) => {
      closePanel();
      navigate('/documents');
    },
  },
  {
    id: 'help',
    labelKey: 'neuneu.action.help',
    icon: HelpCircle,
    run: ({ navigate, closePanel }) => {
      closePanel();
      navigate('/help');
    },
  },
  {
    id: 'support',
    labelKey: 'neuneu.action.support',
    icon: LifeBuoy,
    run: ({ navigate, closePanel }) => {
      closePanel();
      navigate('/support');
    },
  },
];
